export class Filters{

    sales ='All';
    region='All';
    sector='All';
    status='All';   // from null
    public quarter : string[] = [];
    public year : string[] = [new Date().getFullYear()+''];
    public renewable : boolean  = false;
    public partner : boolean  = false;
    public sbmchannel: string  = 'All';
    public productKind : string[] = ['SWG','STG'];
    gstatus = 'All';
    customersFilter = 'All';
    opportunitiesNameFilter = 'All';
    ownersNameFilter = 'All';
    public month : string[];

  }
